import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckTutorial } from './providers/check-tutorial.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'inbox',
    loadChildren: () => import('./pages/inbox/inbox.module').then(m => m.InboxPageModule)
  },
  {
    path: 'schedule',
    loadChildren: () => import('./pages/schedule/schedule.module').then(m => m.ScheduleModule)
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignUpModule)
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/tabs-page/tabs-page.module').then(m => m.TabsModule)
  },
  {
    path: 'tutorial',
    loadChildren: () => import('./pages/tutorial/tutorial.module').then(m => m.TutorialModule),
    canLoad: [CheckTutorial]
  },
  {
    path: 'pq',
    loadChildren: () => import('./pages/pq/pq.module').then( m => m.PqPageModule)
  },
  {
    path: 'ri',
    loadChildren: () => import('./pages/ri/ri.module').then( m => m.RiPageModule)
  },
  {
    path: 'lw',
    loadChildren: () => import('./pages/lw/lw.module').then( m => m.LwPageModule)
  },
  {
    path: 'iq',
    loadChildren: () => import('./pages/iq/iq.module').then( m => m.IqPageModule)
  },
  {
    path: 'wr',
    loadChildren: () => import('./pages/wr/wr.module').then( m => m.WrPageModule)
  },
  {
    path: 'videocall',
    loadChildren: () => import('./pages/videocall/videocall.module').then( m => m.VideocallPageModule)
  },
  {
    path: 'mensaje',
    loadChildren: () => import('./pages/mensaje/mensaje.module').then( m => m.MensajePageModule)
  },
  {
    path: 'pqnext',
    loadChildren: () => import('./pages/pqnext/pqnext.module').then( m => m.PqnextPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardModule)
  },

  {
    path: 'book-session',
    loadChildren: () => import('./pages/book-session/book-session.module').then( m => m.BookSessionModule)
  },
  {
    path: 'book-session/:trainerId',
    loadChildren: () => import('./pages/book-session/book-session.module').then( m => m.BookSessionModule)
  },
  {
    path: 'find-trainer',
    loadChildren: () => import('./pages/find-trainer/find-trainer.module').then( m => m.FindTrainerModule)
  },
  {
    path: 'trainers',
    loadChildren: () => import('./pages/trainers/trainers.module').then( m => m.TrainersModule)
  },

  {
    path: 'sessions',
    loadChildren: () => import('./pages/sessions/sessions.module').then( m => m.SessionsModule)
  },
  {
    path: 'my-programs',
    loadChildren: () => import('./pages/my-programs/my-programs.module').then( m => m.MyProgramsModule)
  },

  {
    path: 'session-details',
    loadChildren: () => import('./pages/session-details/session-details.module').then( m => m.SessionDetailsModule)
  },
  {
    path: 'pricing',
    loadChildren: () => import('./pages/pricing/pricing.module').then( m => m.PricingPageModule)
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}

